import cx from "classnames";
import React from "react";
import PropTypes from 'prop-types';

import styles from './StatusIndicator.scss';

const statusPropType = PropTypes.shape({
    name: PropTypes.string.isRequired,
    message: PropTypes.string,
    icon: PropTypes.func
});

/**
 * Renders a status indicator floating centered in parent element.
 * @param {object} status
 *      current status - must be one of the objects from statusEnum
 * @param {boolean} initial
 *      whether the component is in its initial state
 * @param {object} statusEnum
 *      enumeration of all possible status
 * @param {object} customStyles
 *      (optional) custom stylesheet for coloring of status (status name is used as CSS class)
 * @return {*[]}
 * @constructor
 */
const StatusIndicator = ({status, initial, statusEnum, styles: customStyles}) => (
    <div className={styles.StatusIndicator}>{
        Object.entries(statusEnum).map(([, {name, message, icon: Icon}]) => (message && (
            <div key={name} className={cx([
                styles.status, (customStyles && customStyles.status) || null,
                !initial && // initially no '.hidden' to work around CSS-animation issue
                    styles[(name === status.name) ? 'visible' : 'hidden'],
                (customStyles && customStyles[name]) || null
            ])}>
                <Icon />
                <span>{message}</span>
            </div>
        )))
    }</div>
);
StatusIndicator.propTypes = {
    status: statusPropType,
    initial: PropTypes.bool.isRequired,
    statusEnum: PropTypes.objectOf(statusPropType).isRequired,
    styles: PropTypes.object
};

export default StatusIndicator;
